export class NumberUtils {

  static isNumber(input: any): boolean {
    return input != null && (typeof input == 'string' || typeof input == 'number') && !isNaN(+input) && input !== '';
  }

}
